import React from "react";
import logo from "../pages/byn-logo.jpeg";

const LoadingScreen = ({ progress }) => {
  return (
    <div className="min-h-screen w-full bg-white flex flex-col">

      {/* 🔝 TOP LOGO (BLINKING) */}
      <div className="pt-14 flex justify-center">
        <img
          src={logo}
          alt="Book Your Need"
          className="w-64 h-64 object-contain animate-pulse"
        />
      </div>

      {/* ⏳ CENTER LOADING (ACTUALLY CENTERED) */}
      <div className="flex-1 flex flex-col items-center justify-center -mt-24">
        <p className="text-gray-600 mb-4 text-sm animate-pulse">
          Loading your experience…
        </p>

        {/* Progress Bar */}
        <div className="w-64 h-3 bg-gray-200 rounded-full overflow-hidden shadow-inner">
          <div
            className="h-full bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600 transition-all duration-300"
            style={{ width: `${progress}%` }}
          />
        </div>

        {/* Percentage */}
        <p className="mt-3 text-gray-500 text-xs">
          {progress}%
        </p>
      </div>
    </div>
  );
};

export default LoadingScreen;

